export enum TablesApiMethods {
    createTables = "Tables.CreateTables",
    createTable = "Tables.CreateTable",
    deleteTable = "Tables.DeleteTable",
    getTables = "Tables.GetTables",
    TablesGetTablesWithOrdersInfo = "Tables.GetTablesWithOrdersInfo",
    updateTable = "Tables.UpdateTable",
    getExternalTables = "Tables.GetExternalTables",
    updateTableExternalId = "Tables.UpdateTableExternalId",

}
